import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function MockGatewayPage() {

  const { authority } = useParams();
  const navigate = useNavigate();

  const callbackUrl = "/payment-result";


  const handleSuccess = () => {
    window.location.href =
      `${callbackUrl}?Authority=${authority}&Status=OK`;
  };

  const handleFail = () => {
    window.location.href =
      `${callbackUrl}?Authority=${authority}&Status=NOK`;
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 space-y-6">
      <h2 className="text-2xl font-bold">درگاه پرداخت زرین‌پال (Mock)</h2>

      <div className="flex gap-4">
        <button
          onClick={handleSuccess}
          className="px-6 py-3 bg-green-600 text-white rounded-lg">
          پرداخت موفق
        </button>

        <button
          onClick={handleFail}
          className="px-6 py-3 bg-red-600 text-white rounded-lg">
          پرداخت ناموفق
        </button>
      </div>
    </div>
  );
}
